<div class="container-fluid question-divider"  [id]="question?.code">
    <div class="question-body">
        <div class="question-text">{{question.questionText}}</div>     
        <form #form="ngForm" class="question-form" novalidate [ngSwitch]="question.caseDataQuestionMeta.dataType"
              (ngSubmit)="answer()">
            <div>
                <div *ngSwitchCase="AttributeType.BOOLEAN">
                    <jhi-boolean-input [(value)]="answerValue" [valueText]="question.answerText"
                        [question]="question"
                                       [nullable]="false"
                                       (action)="answer()"
                                       [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-boolean-input>
                </div>
                <div *ngSwitchCase="AttributeType.NUMERIC">
                    <jhi-numeric-input [(value)]="answerValue" [placeholder]="answerPlaceholder"
                                       [disabled]="!form.valid"
                                       [name]="question.code"
                                       [min]="question.caseDataQuestionMeta.minimum"
                                       [max]="question.caseDataQuestionMeta.maximum"
                                       (action)="answer()"
                                       [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-numeric-input>
                </div>
                <div *ngSwitchCase="AttributeType.DATE">
                    <jhi-date-input [(value)]="answerValue" [placeholder]="answerPlaceholder"
                                    [disabled]="!form.valid" [granularity]="DateElement.DAY"
                                    (action)="answer()"
                                    [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-date-input>
                </div>
                <div *ngSwitchCase="AttributeType.TEXT">
                    <jhi-text-input [(value)]="answerValue" [placeholder]="answerPlaceholder"
                                    [name]="question.code"
                                    [min]="question.caseDataQuestionMeta.minimum"
                                    [max]="question.caseDataQuestionMeta.maximum"
                                    [disabled]="!form.valid"
                                    (action)="answer()"
                                    [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-text-input>
                </div>
                <div *ngSwitchCase="AttributeType.NOTE">
                    <jhi-note-input [(value)]="answerValue" [placeholder]="answerPlaceholder"
                                    [disabled]="!form.valid"
                                    [name]="question.code"
                                    [min]="question.caseDataQuestionMeta.minimum"
                                    [max]="question.caseDataQuestionMeta.maximum"
                                    (action)="answer()"
                                    [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-note-input>
                </div>
                <div *ngSwitchCase="AttributeType.SELECTION">
                    <jhi-select-input [name]="question.code" [options]="answerOptions"
                                      [(value)]="answerValue"
                                      [valueMapper]="toOptionValue" [labelMapper]="toOptionLabel"
                                      (action)="answer()"
                                      [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-select-input>
                </div>
                <div *ngSwitchCase="AttributeType.MULTISELECTION">
                    <jhi-multi-select-input [name]="question.code" [options]="answerOptions"
                                            [(value)]="answerValue"
                                            [valueMapper]="toOptionValue" [labelMapper]="toOptionLabel"
                                            (action)="answer()"
                                            [summaryMode]="summaryMode"
                                       [question]="question">
                    </jhi-multi-select-input>
                </div>
            </div>
        </form>
    </div>
    <div class="mt-2" *ngIf="httpErrorMsg">
        <div class="col-12 alert alert-danger">
            {{httpErrorMsg}}
        </div>
    </div>
</div>
